const deJSON = {
  'Templates request has failed': 'Anfrage für Vorlagen fehlgeschlagen', // /content/Templates/index.
  'Template Library': 'Vorlagenbibliothek', // /content/Templates/index.
  'Graphics request has failed': 'Anfrage für Grafiken fehlgeschlagen', // /content/Graphics/index.
  'My graphics': 'Meine Grafiken', // /content/Graphics/index.
  'Go to templates list': 'Zur Vorlagenliste gehen', // /content/Graphics/index.
  Copy: 'Kopieren', // /content/Graphics/_component/Graphic.
  Edit: 'Bearbeiten', // /content/Graphics/_component/Graphic.
  Delete: 'Löschen', // /content/Graphics/_component/Graphic.
  'View templates list': 'Vorlagenliste anzeigen', // /content/Overview/Hero/index.
  'Preview image': 'Bildvorschau', // /content/Editor/_component/EditorForm/EditorForm.
  'Guud Creative Studio': 'Guud Creative Studio', // /component/Logo/index.
  'Image editor': 'Bildeditor', // /component/EditImageModal/index.
  'Use this dialog window to edit a image':
    'Verwenden Sie dieses Dialogfenster, um ein Bild zu bearbeiten', // /component/EditImageModal/index.
  Cancel: 'Abbrechen', // /component/EditImageModal/index.
  'Save image': 'Bild speichern', // /component/EditImageModal/index.
  Version: 'Version', // /component/Logo/index.
  'Edit this image': 'Dieses Bild bearbeiten', // /component/UploadImageField/index.
  'Remove this image': 'Dieses Bild entfernen', // /component/UploadImageField/index.
  'Choose a file or drag it here': 'Wähle eine Datei oder ziehe sie hierher', // /component/UploadImageField/index.
  'Editor form': 'Editor-Formular', // /component/Editor/Templates/TemplateResizer.
  'Graphic has been successfully': 'Grafik wurde erfolgreich erstellt', // /layout/CreativeStudioLayout/EditorHeader/index.
  'Go to graphics selection': 'Zur Grafikauswahl gehen', // /layout/CreativeStudioLayout/EditorHeader/index.
  'Go to template selection': 'Zur Vorlagenauswahl gehen', // /layout/CreativeStudioLayout/EditorHeader/index.
  'Text is too long': 'Text ist zu lang', // /layout/CreativeStudioLayout/EditorHeader/index.
  Download: 'Herunterladen', // /layout/CreativeStudioLayout/EditorHeader/index.
  Save: 'Speichern', // /layout/CreativeStudioLayout/EditorHeader/index.
  'Language Switcher': 'Sprachumschalter', // /layout/CreativeStudioLayout/Header/Buttons/LanguageSwitcher/index.
  Profile: 'Profil', // /layout/CreativeStudioLayout/Header/Userbox/index.
  Inbox: 'Posteingang', // /layout/CreativeStudioLayout/Header/Userbox/index.
  Project: 'Projekt', // /layout/CreativeStudioLayout/Header/Userbox/index.
  'Sign out': 'Abmelden', // /layout/CreativeStudioLayout/Header/Userbox/index.
  'Sign in': 'Anmelden', // /layout/CreativeStudioLayout/Header/Userbox/index.
  Workspaces: 'Arbeitsbereiche', // /layout/CreativeStudioLayout/Sidebar/SidebarMenu/items.
  'Social Accounts': 'Soziale Konten', // /layout/CreativeStudioLayout/Sidebar/SidebarMenu/items.
  'Everything you need to create beautiful designs that will engage your audience. Select a template to get started and make your own images for your business and social media.':
    'Alles, was Sie brauchen, um wunderschöne Designs zu erstellen, die Ihre Zielgruppe ansprechen. Wählen Sie eine Vorlage aus, um zu beginnen, und erstellen Sie Ihre eigenen Bilder für Ihr Unternehmen und Ihre sozialen Medien.', // /layout/Content/Overview/Hero/index.
  'Start creating designs that will impress':
    'Beginnen Sie mit der Erstellung von Designs, die beeindrucken', // /layout/Content/Overview/Hero/index.
  Editor: 'Editor', // /layout/Content/Overview/Sidebar/SidebarMenu/items.
  'Create images and videos in seconds':
    'Erstellen Sie Bilder und Videos in Sekunden',
  'Start from a template': 'Starten Sie von einer Vorlage aus',
  'Template tags': 'Vorlage-Tags',
  'Select tags...': 'Tags auswählen...',
  Search: 'Suche',
  'No templates are available. Contact Guud.tv':
    'Es sind keine Vorlagen vorhanden. Kontakt zu Guud.tv',
  //Graphics view
  'Start creating amazing graphics': 'Erstellen Sie beeindruckende Grafiken',
  'Search by name': 'Grafiken nach Namen suchen',
  //Settings view
  Settings: 'Einstellungen',
  Colors: 'Farben',
  "You don't have colors yet, start creating them":
    'Sie haben noch keine Farben, fangen Sie an, sie zu kreieren',
  'Create color': 'Farbe schaffen',
  'Add color': 'Farbe hinzufügen',
  'Color name': 'Name der Farbe',
  // Account / Payment view
  Trial: 'Versuch'
};
export default deJSON;
